import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import ico_moneda from './../../../../assets/icons/ico_moneda.svg';
import ico_billete from './../../../../assets/icons/ico_billete.svg';
import ico_loading from './../../../../assets/icons/ico_loading.gif';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import HeaderComponent from '../../../../components/header/header_component';
import { getProductCatalog } from '../../../../redux/reducers/productCatalogsSlice';
import { getValidarEndosoPoliza } from '../../../../redux/reducers/endosoPolizaSlice';
import { addTipoEndoso } from '../../../../redux/reducers/refundInformationSlice';
import cn from '../../../../lib/bem';

import './serviciosGestionInversion.scss';


const ServiciosGestionInversion = () => {
  
    const history = useNavigate();
    const dispatch = useDispatch();
    const classes = cn("serviciosGestionInversion");

    const [ cargandoProd, setCargandoProd ] = useState(false);
    const [ cargandoResc, setCargandoResc ] = useState(false);

    const cargarInfoDevolucion = () => {
        consultaServicios( true,'/devolucion', 'DEV');
    }

    const cargarConsultaRescate = () => {
        consultaServicios( false,'/rescate', 'RES');
    } 

    const consultaServicios = (accion, navegacion, tipoEndoso) => {
        const polizaInfo = JSON.parse(sessionStorage.getItem("infoPoliza"));
        accion === true ? setCargandoProd(true) : setCargandoResc(true);
        dispatch(addTipoEndoso(tipoEndoso));
        dispatch(getProductCatalog()).then( resp => {
            dispatch(getValidarEndosoPoliza({
                "idPoliza" : polizaInfo?.numpol,
                "idProducto" : polizaInfo?.codprod,
                "tipoEndoso" : tipoEndoso
            })).then( resp2 => {
                accion === false ? setCargandoProd(false) : setCargandoResc(false);;
                history(navegacion);
            });
        });
    }

    const flagHabilitarRescate = process.env.REACT_APP_FLAG_HABILITAR_RESCATE === "true";
            
    return (
        <div className={classes()}>

            <HeaderComponent flagHeaderMobile={true} index={true} title={"Gestiona tus inversiones"}/>

            <div className={classes('listCard')}>
                {
                    flagHabilitarRescate &&
                        <div className={classes('card')} onClick={() => cargarConsultaRescate()}>
                            <div className={classes('cardItem')}>
                                <img src={ico_billete} alt='cobrar' />
                                <p>Consulta de Rescate</p>
                            </div>
                            { cargandoResc ? <img src={ico_loading} alt='cargando' /> : <FontAwesomeIcon icon={faChevronDown} /> }
                        </div>
                }
                <div className={classes('card')} onClick={() => cargarInfoDevolucion()}>
                    <div className={classes('cardItem')}>
                        <img src={ico_moneda} alt='cobrar' />
                        <p>Finalizaci&oacute;n de plazo de p&oacute;liza</p>
                    </div>
                    { cargandoProd ? <img src={ico_loading} alt='cargando' /> : <FontAwesomeIcon icon={faChevronDown} /> }
                </div>
            </div>

        </div>
    );

}
export default ServiciosGestionInversion;
